// extracted by mini-css-extract-plugin
export default {"leaflet-popup-content":"MapMarker_leaflet-popup-content__RiYPD","trainBigImage":"MapMarker_trainBigImage__k2AEp"};